import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Information = () => {
    return (
        <div>
            <Helmet>
                <title>Information | .rq Lab Projects and Engineering Work</title>
                <meta
                    name="description"
                    content="Recent .rq Lab work in performance engineering, CUDA-oriented simulations, and browser extension tooling."
                />
                <link rel="canonical" href="https://roamingquark.info/information" />
            </Helmet>
            <h2>Information</h2>
            <p>Recently developed projects are:</p>
            <p>Was involved in Boltzman Lattice implementation for TurbulentDynamics, optimized for Cuda: <a href="https://github.com/TurbulentDynamics/tdLBCpp" target="_blank" rel="noopener noreferrer">tdLBCpp on GitHub</a></p>
            <p>Change Audio device plugin for Firefox: <a href="https://addons.mozilla.org/en/firefox/addon/chaudev" target="_blank" rel="noopener noreferrer">Chaudev at Mozilla Add-Ons</a></p>
            <p>Please check <Link to="/contacts">Contacts</Link> for communication.</p>
        </div>
    )
}

export default Information;
